import { SimpleLink } from '@components/simpleLink';
import { useFragment } from 'react-relay';
import { pageFooterFragment } from './PageFooter.relay';
import type { PageFooterPropsType } from './types';

function PageFooter(props: PageFooterPropsType) {
  const siteFooter = useFragment(pageFooterFragment, props.siteFooter);

  return (
    <footer
      data-page-footer={true}
      className="relative mx-auto max-w-[1400px] text-base font-normal font-[BonnCaps,Arial,sans-serif] uppercase tracking-widest text-black no-underline transition-colors duration-500 max-[1500px]:max-w-[1000px] in-[.no-bonncapps]:font-[Arial,sans-serif] [&_a]:text-black [&_a]:no-underline [&_a]:transition-colors [&_a]:duration-500 [&_a:hover]:text-[#979899]"
    >
      <nav>
        <ul className="my-10 transition-all duration-1000 max-[1500px]:my-6 max-[1500px]:mx-5 max-[1500px]:mb-10 max-[968px]:block">
          {siteFooter.footer.map((link, index) => (
            <li key={index} className="list-none inline-block mr-4 transition-all duration-1000 max-[968px]:block max-[968px]:mb-4 [&_a]:font-normal [&_a]:text-[10px]">
              <SimpleLink simpleLink={link} />
            </li>
          ))}
        </ul>
      </nav>
    </footer>
  );
}

export { PageFooter };
